import axios from 'axios';

axios.defaults.baseURL = `${process.env.REACT_APP_API_DOMAIN}/`;
if (localStorage.getItem('token')) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('token') || null}`;
}

export default axios;
